import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, switchMap, tap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';
import { SearchModel } from '@core/models';
import { SearchService } from '@core/services';

type SearchState = {
  isLoading: boolean;
  searchs: SearchModel;
};
const emptyData: SearchModel = {
  partners: [],
  locations: [],
  devices: [],
  installations: [],
};

const initialState: SearchState = {
  isLoading: false,
  searchs: emptyData,
};

export const SearchStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store, searchService = inject(SearchService)) => ({
    searchsMethod: rxMethod<string>(
      pipe(
        tap(() => patchState(store, { isLoading: true })),
        switchMap(text => {
          return searchService.getSearchs(text).pipe(
            tapResponse({
              next: data => {
                patchState(store, {
                  searchs: { ...data, installations: data.installations ?? [] },
                  isLoading: false,
                });
              },
              error: () => {
                patchState(store, { searchs: emptyData, isLoading: false });
              },
            }),
          );
        }),
      ),
    ),
  })),
);
